import Layout from "@/components/Layout";
import PageHero from "@/components/PageHero";
import BookSection from "@/components/BookSection";
import SeasonalReminder from "@/components/SeasonalReminder";

export default function ContactPage() {
  return (
    <Layout>
      <PageHero
        eyebrow="Book"
        title="Pick a slot on"
        italic="the diary."
        blurb="Live availability, instant confirmation. For anything bespoke, call or email directly — details below."
      />
      <BookSection />
      <SeasonalReminder />
    </Layout>
  );
}
